import it from "./lang/it";
import en from "./lang/en";
import polyglotI18nProvider from 'ra-i18n-polyglot';

const translations: any = { it, en };
const i18nProvider = polyglotI18nProvider((locale) => translations[locale], localStorage.getItem('locale') ?? 'en', [{ locale: 'en', name: 'English' }, { locale: 'fr', name: 'Français' }]);

export default i18nProvider
